import { useState } from 'react'
import { colors } from '../../colors'
import header from '../../images/header-inverted.png'
import { BargainUserInfo } from '../../types'
import LoginModal from '../LoginModal'

interface PageHeaderProps {
  title: string
  backgroundColor?: string
  textColor?: string
  className?: string
  style?: React.CSSProperties
  bargain_user_info?: BargainUserInfo
}

const styles: Record<string, React.CSSProperties> = {
  header: {
    backgroundColor: colors.white,
    color: colors.white,
    padding: '9px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerText: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 'bold',
  },
  headerImg: {
    width: 'calc(100% - 8px)',
    maxWidth: '238px',
    maxHeight: '49px',
    verticalAlign: 'middle',
    margin: '0 4px',
  },
  mypageTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
  },
  iconStyle: {
    fontSize: '26px',
    color: colors['keijiban-brown'],
    lineHeight: '1.2',
  },
  mypageTitle: {
    fontSize: '10px',
    fontWeight: 'bold',
    lineHeight: '1.2',
    color: colors['keijiban-brown'],
    whiteSpace: 'nowrap',
  },
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  backgroundColor = colors.white,
  textColor = colors.white,
  className,
  style,
  bargain_user_info,
}) => {
  const [showLoginModal, setShowLoginModal] = useState(false)

  const handleMypageClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (bargain_user_info && bargain_user_info.type === 'guest') {
      e.preventDefault()
      setShowLoginModal(true)
    }
  }

  return (
    <>
      <div
        className={className}
        style={{
          ...styles.header,
          backgroundColor,
          color: textColor,
          ...style,
        }}
      >
        <h1 style={styles.headerText}>
          <a href="/message_board">
            <img style={styles.headerImg} src={header} alt={title} />
          </a>
        </h1>

        {bargain_user_info && (
          <a
            style={styles.mypageTitleContainer}
            href={bargain_user_info.type !== 'guest' ? '/webview/message_board/mypage' : '#'}
            onClick={handleMypageClick}
          >
            <span style={styles.iconStyle} className="icon_font icf_user" />
            <span style={styles.mypageTitle}>自分の口コミ</span>
          </a>
        )}
      </div>

      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </>
  )
}

export default PageHeader
